import { CreditCard } from 'lucide-react'
import { TxRegistryTab, type TxRegistryConfig } from '@/components/TxRegistryTab'

const PAYMENT_TYPES = [
  ['cash', '현금'], ['transfer', '계좌이체'], ['check', '수표'],
  ['note', '어음'], ['card', '카드'], ['offset', '상계'],
] as const

const PAYMENTS_CONFIG: TxRegistryConfig = {
  icon: <CreditCard className="w-6 h-6 text-emerald-600"/>,
  headerTitle: '지급등록',

  entityShort: '지급',
  entityDateLabel: '지급일자',
  entityNoLabel: '지급번호',
  entityTypeLabel: '지급유형',
  partnerLabel: '매입처',
  searchPlaceholder: '지급번호, 거래처, 적요 검색',
  emptyText: '이 기간의 지급이 없습니다.',

  apiBase: '/api/payments',
  queryKey: 'payments',

  typeOptions: PAYMENT_TYPES,
  defaultType: 'cash',

  dateField: 'payment_date',
  noField: 'payment_no',
  typeField: 'payment_type',
  typeLabelField: 'payment_type_label',

  partnerBizClass: 'vendor',

  accent: {
    button: 'bg-purple-600 hover:bg-purple-700',
    total: 'text-purple-700',
    typeChip: 'bg-purple-100 text-purple-800',
  },
}

export function PaymentsTab() {
  return <TxRegistryTab config={PAYMENTS_CONFIG} />
}
